<template>
  <div class="panel-item first-panel">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>成交排行</div>

      <div class="btns-box">
        <div :class="type==1?'btn-item-s':'btn-item'" @click="type=1">店铺</div>
        <div :class="type==2?'btn-item-s':'btn-item'" @click="type=2">商品</div>
      </div>
    </div>
    <dv-scroll-board :config="config" class="panel-item_datav"/>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      type: 1,//1 店铺、2 商品


      config: {
        header: ['排名', '店铺名', '总成交金额'],
        data: [],
        headerBGC: '#053355',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        headerHeight: 30,
        hoverPause: true,
        // waitTime: 99999999,
        align: ['left', 'center', 'center'],
        columnWidth: [80, 200, 140] // 调整列宽，中间列为产品名称宽度

      },
      detailVisible: false,
      detail: {},

    }
  },
  mounted() {
  },
  methods: {
    setData(newVal){
      const newData = newVal.map((item, index) => [
        `<div class="index${index} left_box">${index > 2 ? index + 1 : ''}</div>`,
        // 为产品名称添加 title 属性，鼠标悬浮时显示完整名称
        `<div >${(this.type == 1?item.shop_name:item.goods_name) || ''}</div>`,
        `<div class="right_box">${item.actual_paid || '0'}</div>`
      ])

      //1 店铺、2 商品
      if (this.type == 1) {
        this.config.header[1] = '店铺名'
      } else if (this.type == 2) {
        this.config.header[1] = '商品名'
      }
      this.config = Object.assign({}, this.config, {
        data: newData
      })
    }
  },
// 修改 watch 中的 datas 处理逻辑
  watch: {
    datas: {
      immediate: true,
      handler(tNew) {
        let newVal
        //1 店铺、2 商品
        if (this.type == 1) {
          newVal = tNew.shop_data
        } else if (this.type == 2) {
          newVal = tNew.product_data
        }
        // if (newVal.length == 0) return
        this.setData(newVal)
      },
    },
    type: {
      handler(newType) {
        let newVal
        if (newType == 1) {
          newVal = this.datas.shop_data
        } else if (newType == 2) {
          newVal = this.datas.product_data
        }
        if (newVal.length == 0) return
        this.setData(newVal)
      },
    }
  }

}
</script>

<style lang="scss" scoped>

.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  .title_name {
    padding: 30px 0 20px 100px;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }

  .panel-item_datav {
    padding: 0 30px 20px 30px;
    width: calc(100% - 60px);
    height: 300px;
  }

}

.btns-box {
  display: flex;
  padding-right: 20px;
  gap: 10px;
  font-size: 16px;

  .btn-item {
    width: 60px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url(../../../../assets/head_btn2.png) no-repeat;
    background-size: 100% 100%;
  }

  .btn-item-s {
    width: 60px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url(../../../../assets/head_btn.png) no-repeat;
    background-size: 100% 100%;
  }
}


//表头
::v-deep .header-item {
  height: 38px !important;
  line-height: 38px !important;
  font-size: 18px;
}

//单行
::v-deep .row-item {
  font-size: 18px;
  border-bottom: 1px dashed rgba(255, 255, 255, .2);
}

::v-deep .ceil {
  text-align: center;
}

// 排名
::v-deep .left_box {
  line-height: 30px !important;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking.png) no-repeat;
  background-size: 30px 30px;
}


::v-deep .index0 {
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking1.png) no-repeat !important;
  background-size: 30px 30px !important;
}

::v-deep .index1 {
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking2.png) no-repeat !important;
  background-size: 30px 30px !important;
}

::v-deep .index2 {
  line-height: 30px;
  margin-top: 10px;
  height: 30px;
  width: 30px;
  background: url(../../../../assets/ranking3.png) no-repeat !important;
  background-size: 30px 30px !important;
}

// 数量
::v-deep .right_box {
  width: 50%;
  height: 24px;
  line-height: 24px;
  background: #00BAFF;
  font-weight: bold;
  color: #06162A;
  transform: translate(50%, 70%);
}
</style>